import { select } from '@panel/commons/core/themev2';
import styled, { css } from 'styled-components';

const Container = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${({ device }) => (device === 'mobile' ? '20px 16px 12px' : '24px')};
`;

const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  ${({ device }) => {
    return (
      device === 'mobile' &&
      css`
        flex-direction: column;
        align-items: flex-start;
        gap: 0px;
      `
    );
  }}
`;

const StyledLink = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

const Title = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${select('midDarkGrayAux')};
`;

const StageLabel = styled.div`
  color: ${select('midDarkGrayAux')};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

export { Container, StyledLink, Title, InfoWrapper, StageLabel };
